module.exports = __webpack_public_path__ + "static/media/travel1.0eabe612.jpg";